import { Component, ChangeDetectionStrategy } from '@angular/core';

import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';
import { UnitsDistributionBase } from '../base/units-distribution.base';

@Component({
    selector: 'ud-fantasy-ou',
    templateUrl: './fantasy-ou/fantasy-ou.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslocoModule, PipesModule]
})
export class FantasyOuComponent extends UnitsDistributionBase {
  override getUnits(distribution: any): number {
    return super.getUnits(distribution);
  }
}